module.exports = __webpack_public_path__ + "static/img/s15.d4732adc.png";